import React from 'react';
import './App.css';
import Roster from '../../util/Roster';
import Matchup from '../Matchup/Matchup';
import CharacterSelect from '../CharacterSelect/CharacterSelect';
import Counters from '../Counters/Counters';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: Roster.mode,
      roster: Roster.fighters,
      selected: Roster.fighters.selected,
      opponent: Roster.fighters.opponent,
      counters: Roster.fighters.counters,
      maxMetric: 10
    }
    this.selectMode = this.selectMode.bind(this);
    this.selectOpponent = this.selectOpponent.bind(this);
    this.randomizer = this.randomizer.bind(this);
  }

  selectMode(mode) {
    Roster.setMode(mode);
    Roster.updatePlayMetrics(Roster.fighters.opponent.keyName, Roster.mode);
    Roster.findMaxMetric();
    this.setState({mode: Roster.mode,
                   maxMetric: Roster.maxMetric});
  }

  selectOpponent(fighterKeyName) {
    Roster.setOpponent(Roster[fighterKeyName]);
    Roster.updatePlayMetrics(Roster.fighters.opponent.keyName, this.state.mode);
    Roster.findMaxMetric();
    Roster.findCounterArray(Roster.fighters.opponent.keyName);
    this.setState({opponent: Roster.fighters.opponent,
                  counters: Roster.fighters.counters,
                  maxMetric: Roster.maxMetric});
  }

  randomizer() {
    Roster.randomizeFighter(this.state.opponent.keyName, this.state.mode);
    Roster.updatePlayMetrics(Roster.fighters.opponent.keyName, this.state.mode);
    Roster.findMaxMetric();
    /*Django Connectioned disabled for demo
    fetch(`http://localhost:8000/roster/1/`,{
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      method: 'PATCH',
      body: JSON.stringify(Roster.djangoMetrics)
    }).then(response => {
      console.log(response);
    })
    */
    this.setState({selected: Roster.fighters.selected,
                   maxMetric: Roster.maxMetric});
  }

  /* Django connections disabled for demo
  componentWillMount() {
    fetch('http://localhost:8000/roster/1/', {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    }).then(response => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error('Server probably not on.');
      }
    }, networkError => console.log(networkError.message)
  ).then(roster => {
      Roster.maxMetric = roster.maxMetric;
      Roster.mario.loadFavor(Number(roster.mario));
      Roster.luigi.loadFavor(Number(roster.luigi));
      Roster.peach.loadFavor(Number(roster.peach));
      Roster.bowser.loadFavor(Number(roster.bowser));
      Roster.yoshi.loadFavor(Number(roster.yoshi));
      Roster.rosalina.loadFavor(Number(roster.rosalina));
      Roster.bowserJr.loadFavor(Number(roster.bowserJr));
      Roster.wario.loadFavor(Number(roster.wario));
      Roster.donkeyKong.loadFavor(Number(roster.donkeyKong));
      Roster.diddyKong.loadFavor(Number(roster.diddyKong));
      Roster.mrGameAndWatch.loadFavor(Number(roster.mrGameAndWatch));
      Roster.littleMac.loadFavor(Number(roster.littleMac));
      Roster.link.loadFavor(Number(roster.link));
      Roster.zelda.loadFavor(Number(roster.zelda));
      Roster.sheik.loadFavor(Number(roster.sheik));
      Roster.ganondorf.loadFavor(Number(roster.ganondorf));
      Roster.toonLink.loadFavor(Number(roster.toonLink));
      Roster.samus.loadFavor(Number(roster.samus));
      Roster.zss.loadFavor(Number(roster.zss));
      Roster.pit.loadFavor(Number(roster.pit));
      Roster.palutena.loadFavor(Number(roster.palutena));
      Roster.marth.loadFavor(Number(roster.marth));
      Roster.ike.loadFavor(Number(roster.ike));
      Roster.tactician.loadFavor(Number(roster.tactician));
      Roster.duckHunt.loadFavor(Number(roster.duckHunt));
      Roster.kirby.loadFavor(Number(roster.kirby));
      Roster.kingDedede.loadFavor(Number(roster.kingDedede));
      Roster.metaKnight.loadFavor(Number(roster.metaKnight));
      Roster.fox.loadFavor(Number(roster.fox));
      Roster.falco.loadFavor(Number(roster.falco));
      Roster.pikachu.loadFavor(Number(roster.pikachu));
      Roster.charizard.loadFavor(Number(roster.charizard));
      Roster.lucario.loadFavor(Number(roster.lucario));
      Roster.jigglypuff.loadFavor(Number(roster.jigglypuff));
      Roster.greninja.loadFavor(Number(roster.greninja));
      Roster.rob.loadFavor(Number(roster.rob));
      Roster.ness.loadFavor(Number(roster.ness));
      Roster.captainFalcon.loadFavor(Number(roster.captainFalcon));
      Roster.villager.loadFavor(Number(roster.villager));
      Roster.olimar.loadFavor(Number(roster.olimar));
      Roster.wiiFitTrainer.loadFavor(Number(roster.wiiFitTrainer));
      Roster.shulk.loadFavor(Number(roster.shulk));
      Roster.drMario.loadFavor(Number(roster.drMario));
      Roster.darkPit.loadFavor(Number(roster.darkPit));
      Roster.lucina.loadFavor(Number(roster.lucina));
      Roster.pacMan.loadFavor(Number(roster.pacMan));
      Roster.megaMan.loadFavor(Number(roster.megaMan));
      Roster.sonic.loadFavor(Number(roster.sonic));
      Roster.mewTwo.loadFavor(Number(roster.mewTwo));
      Roster.lucas.loadFavor(Number(roster.lucas));
      Roster.roy.loadFavor(Number(roster.roy));
      Roster.ryu.loadFavor(Number(roster.ryu));
      Roster.cloud.loadFavor(Number(roster.cloud));
      Roster.corrin.loadFavor(Number(roster.corrin));
      Roster.bayonetta.loadFavor(Number(roster.bayonetta));
      Roster.qezox.loadFavor(Number(roster.qezox));
      Roster.daciex.loadFavor(Number(roster.daciex));
      Roster.zeldark.loadFavor(Number(roster.zeldark));
    }).then(() => {
      Roster.updatePlayMetrics(Roster.fighters.opponent.keyName, this.state.mode);
      this.setState({
        roster: Roster.fighters,
        maxMetric: Roster.maxMetric
      })
    });
  }
  */
  render() {
    return (
      <div>
        <Matchup roster={this.state.roster} selected={this.state.selected} opponent={this.state.opponent} selectMode={this.selectMode} selectOpponent={this.selectOpponent} randomizer={this.randomizer}/>
        <CharacterSelect roster={this.state.roster} opponent={this.state.opponent} maxMetric={this.state.maxMetric} />
        <Counters roster={this.state.roster} opponent={this.state.opponent}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App/App.js